export const BLOCK_TYPE_PROMO = 'promo';
export const BLOCK_TYPE_SLIDER = 'slider';
export const BLOCK_TYPE_BANNERS = 'banners';
export const BLOCK_TYPE_FULLSCREEN_BANNER = 'fullScreenBanner';
export const BLOCK_TYPE_INFOGRAPHIC = 'infographic';
export const BLOCK_TYPE_CUSTOM = 'custom';
export const BLOCK_TYPE_BEAUTY_CONTENT = 'beautyContent';
export const BLOCK_TYPE_ARTICLES = 'articles';
export const BLOCK_TYPE_TAGS = 'tags';
export const BLOCK_TYPE_GOODS_DAY = 'goodsDay';
export const BLOCK_TYPE_VIDEOS = 'videos';
